<div class="bg-m0 flex h-[87vh] w-[90vw] select-none flex-col p-9">
  <div
    data-cy="editListenDialogTitle"
    class="text-s2 mt-5 cursor-default text-left text-2xl font-semibold"
    >Edit Listeners</div
  >

  <div
    data-cy="editListenDialogInfo"
    class="text-s1 mb-6 mt-2 cursor-default text-left text-xl"
    >Map dashboard filters to tile's model fields</div
  >

  <div class="flex flex-1 flex-row items-center justify-center" *ngIf="!models">
    <div class="relative flex h-9 w-9 flex-shrink-0">
      <ngx-spinner
        [name]="spinnerName"
        color="#0084d1"
        bdColor="#00000000"
        size="default"
        type="ball-clip-rotate"
        [fullScreen]="false"
        [disableAnimation]="true"
        [zIndex]="10"
      >
      </ngx-spinner>
    </div>
  </div>

  <div
    class="divide-s500 flex flex-grow flex-col divide-y overflow-auto"
    *ngIf="!!models"
  >
    <div class="text-s1 mb-3 flex cursor-default flex-row space-x-5 text-base">
      <div class="flex w-[500px] flex-shrink-0 font-semibold"> Tile</div>

      <div
        class="flex w-[480px] flex-shrink-0 flex-row"
        *ngFor="let dashboardField of dashboard.fields"
      >
        <div class="flex truncate font-semibold">
          <div class="truncate"> {{ dashboardField.label }}</div>
        </div>

        <div class="ml-2 flex flex-shrink-0">
          <div>
            ({{
              dashboardField.result ??
                dashboardField.storeResult ??
                dashboardField.storeFilter
            }})</div
          >
        </div>
      </div>
    </div>

    <form [formGroup]="listenForm">
      <div
        class="text-s1 border-s300 flex flex-row space-x-5 py-4 text-base"
        [ngStyle]="
          tile.title !== dashboard.tiles[dashboard.tiles.length - 1].title && {
            'border-bottom-width': '1px'
          }
        "
        *ngFor="let tile of dashboard.tiles; let tileIndex = index"
      >
        <div
          class="flex w-[500px] flex-shrink-0 flex-row items-start justify-start"
        >
          <div class="items-start truncate">
            <div class="mt-2 cursor-default truncate">
              {{ tile.title }}
            </div>
          </div>
        </div>

        <div
          class="group flex w-[480px] flex-shrink-0 flex-col space-y-4"
          *ngFor="let dashboardField of dashboard.fields"
        >
          <div
            class="flex flex-row"
            *ngFor="
              let y of tile.mconfigListenSwap[dashboardField.id];
              let i = index
            "
          >
            <ng-select
              #fieldSelect
              [fixNgSelectBottom]="fieldSelect"
              data-cy="fieldSelect"
              class="w-96 text-base"
              [items]="tile.modelFields[dashboardField.id]"
              [clearable]="false"
              [searchable]="true"
              [searchFn]="fieldSearchFn"
              formControlName="{{ tileIndex }}-----{{
                dashboardField.id
              }}-----{{ i }}"
              (change)="
                listenerChange({
                  dashboardFieldId: dashboardField.id,
                  tile: tile,
                  tileIndex: tileIndex,
                  i: i,
                  items: tile.modelFields[dashboardField.id],
                  selected: $event
                })
              "
              (keyup.esc)="
                $event.stopImmediatePropagation(); fieldSelect.blur()
              "
              (keyup.enter)="
                $event.stopImmediatePropagation(); fieldSelect.blur()
              "
              appendTo="body"
              bindLabel="id"
              bindValue="id"
            >
              <ng-template ng-label-tmp let-item="item">
                <div class="ml-1 flex flex-row items-center">
                  <m-field-result
                    class="h-5 w-5"
                    [size]="2"
                    [fieldClass]="item.fieldClass"
                    [result]="item.result"
                    [isEmpty]="!item.id"
                  ></m-field-result>

                  <m-field-label
                    *ngIf="!!item.id"
                    [column]="item"
                    class="ml-3 flex"
                  ></m-field-label>
                </div>
              </ng-template>

              <ng-template ng-option-tmp let-item="item">
                <div class="ml-1 flex flex-row items-center">
                  <m-field-result
                    class="h-5 w-5"
                    [size]="2"
                    [fieldClass]="item.fieldClass"
                    [result]="item.result"
                    [isEmpty]="!item.id"
                  ></m-field-result>

                  <m-field-label
                    [column]="item"
                    class="ml-3 flex"
                  ></m-field-label>
                </div>
              </ng-template>
            </ng-select>

            <button
              *ngIf="i === 0"
              class="hover:bg-m50 invisible ml-5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none group-hover:visible"
              (click)="
                addListener({
                  tile: tile,
                  tileIndex: tileIndex,
                  dashboardFieldId: dashboardField.id
                })
              "
            >
              <m-add-icon></m-add-icon>
            </button>

            <button
              *ngIf="i > 0"
              class="hover:bg-m50 invisible ml-5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none group-hover:visible"
              (click)="
                removeListener({
                  event: $event,
                  tile: tile,
                  tileIndex: tileIndex,
                  index: i,
                  dashboardFieldId: dashboardField.id
                })
              "
            >
              <m-delete-icon></m-delete-icon>
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="mt-9">
    <button
      data-cy="editListenDialogApplyButton"
      class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="apply()"
      >Apply</button
    >

    <button
      data-cy="editListenDialogCancelButton"
      class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
      type="button"
      (click)="cancel()"
      >Cancel</button
    >
  </div>
</div>

<div *ngIf="nav$ | async"></div>
